<template>
    <b-modal id="skill-create-modal" :hide-header="true" :hide-footer="true" :centered="true" ref="skill-create-modal">
        <div class="modal-body">
            <a href="#" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close"
               @click="hide()">
                <span aria-hidden="true">&times;</span>
            </a>
            <div>
                <h4 v-if="model.type === 'edit'">Edit Education</h4>
                <h4 v-else>Add New Education</h4>
                <b-form @submit.prevent="submit" enctype="multipart/form-data">
                    <b-form-group label="School Name">
                        <b-input  placeholder="School Name" required v-model="model.educationSchoolName"/>
                    </b-form-group>
                    <b-form-group label="Field">
                      <b-input-group>
                        <b-input placeholder="Field" v-model="model.educationField"/>
                        <b-input placeholder="Degree" v-model="model.educationDegree"/>
                      </b-input-group>
                    </b-form-group>
                    <b-form-group label="Start Date">
                        <b-input type="date" v-model="model.educationStartYear"/>
                    </b-form-group>
                    <b-form-group label="End Date">
                        <b-input type="date" v-model="model.educationEndYear"/>
                    </b-form-group>
                  <b-form-group label="Grade">
                    <b-input v-model="model.educationGrade"/>
                  </b-form-group>
                  <b-form-group label="Activities/Societies">
                    <b-input v-model="model.educationActivities"/>
                  </b-form-group>
                  <b-form-group label="Description">
                    <b-textarea v-model="model.educationDescription"/>
                  </b-form-group>
                  <b-form-group v-if="model.type === 'edit'" label="Status">
                    <b-select required v-model="model.educationStatus">
                      <b-select-option value="ACTIVE">Active</b-select-option>
                      <b-select-option value="DELETED">Delete</b-select-option>
                    </b-select>
                  </b-form-group>
<!--                    <b-form-group label="Status">-->
<!--                        <b-select required v-model="model.employerGradeSalaryItemType">-->
<!--                            <b-select-option  value="ACTIVE">ACTIVE</b-select-option>-->
<!--                            <b-select-option  value="DELETED">DELETE</b-select-option>-->
<!--                        </b-select>-->
<!--                    </b-form-group>-->
                    <base-button title="Submit" :loading="employee.employeeLoading"/>
                </b-form>
            </div>
        </div><!-- modal-body -->
    </b-modal>
</template>
<script>
    import { mapState } from "vuex"
    import BaseButton from "../button/BaseButton";
    export default {
        props:['show','row'],
        components:{BaseButton},
        name: 'ConfirmModal',
        data(){
            return{
                password: '',
                model:{
                  educationId: '',
                  educationEmployeeId: '',
                  educationSchoolName: '',
                  educationDegree: '',
                  educationField: '',
                  educationStartYear: '',
                  educationEndYear: '',
                  educationGrade: '',
                  educationActivities: '',
                  educationStatus: '',
                  educationDescription: ''
                },
            }
        },
        methods:{
            hide() {
                this.$refs['skill-create-modal'].hide()
            },
            async submit(){
                this.model.educationEmployerId = localStorage.orgId
                if (this.model.type === 'edit')
                  await this.$store.dispatch("employee/editEducation", this.model, {root: false});
                else {
                  this.model.educationEmployeeId = this.row.employeeId
                  await this.$store.dispatch("employee/createEducation", this.model, {root: false});
                }
                this.hide();
                this.$store.dispatch('employee/readEducations', {
                  readAll: 'NO',
                  skillEmployeeId: this.row.employeeId?this.row.employeeId:this.model.educationEmployeeId
                })
                let self = this;
                // eslint-disable-next-line no-unused-vars
                Object.keys(this.model).forEach(function(key,index) {
                    self.model[key] = '';
                });

            },
            gradeCode(){
                return  localStorage._gradeCode
            },
            loadGrade(){
                this.$store.dispatch("grade/updateGradeSalaries", {
                    readAll:'NO',
                    employerGradeSalaryEmployerId: localStorage.orgId,
                    employerGradeSalaryGradeCode: localStorage._gradeCode
                }, {root: false}).then()
            },
            hideauth: function () {
                this.password = '';
                this.$refs['skill-create-modal'].hide();
            },
            currentDate(){
                let date = new Date()
                date = this.$moment(date.toDateString()).format('YYYY-MM-DD')
                console.log(date)
                return date
            },
        },
        mounted() {
            //this.model = this.row readSkillCategory
          this.$store.dispatch('employee/readSkillCategory',{readAll:"YES"})
        },
        computed:{
            ...mapState(['grade','auth','employee']),
        },
        watch: {
            show: function () {
                let self = this;
              // eslint-disable-next-line no-unused-vars
                Object.keys(this.model).forEach(function(key,index) {
                  self.model[key] = '';
                });
                // eslint-disable-next-line no-unused-vars
                Object.keys(this.row).forEach(function(key,index) {
                    self.model[key] = self.row[key];
                });
                this.$refs['skill-create-modal'].show()
            }
        },
    }
</script>
